<div class="contentHeight planningContainer">
    <div class="container">
        <div class="head">
            <h3 [translate]="'planning.planningRDV'" class="containerTitle mr-3"></h3>
            <button class="btn btn-secondary btn-sm" id="btnHisto" routerLink="/planningHistorique" [translate]="'planning.manageRDV'"></button>
        </div>

        <!--1. Choix du type d'intervention-->
        <div *ngIf="isLoadingInterventions" class="row justify-content-center mt-5">
            <div class="col-lg-2 col-md-4 col-sm-4 row justify-content-center loader-black">
                <mat-spinner diameter="70"> </mat-spinner>
            </div>
        </div>

        <div *ngIf="isInterventions">
            <div class="col-xl-8 col-lg-10 col-md-12 col-sm-12 mt-2 pt-3 backgroundWhiteRound" id="divSelectIntervention">
                <form [formGroup]="interventionForm" class="col-12 row" id="selectIntervention">
                    <mat-form-field class="col-12">
                        <mat-label>{{'planning.selectIntervention'|translate}}</mat-label>
                        <mat-select (selectionChange)="selectIntervention($event.value)" formControlName="intervention">
                            <mat-option *ngFor="let intervention of interventions"
                                        value="{{intervention.interventionID}}"
                                        title="{{intervention.label}} ({{intervention.duration}} min)">
                                {{intervention.label}} ({{intervention.duration}} min)
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </form>
            </div>
        </div>

        <div *ngIf="isLoadingCreneaux" class="row justify-content-center mt-5">
            <div class="col-lg-2 col-md-4 col-sm-4 row justify-content-center loader-black">
                <mat-spinner diameter="70"> </mat-spinner>
            </div>
        </div>

        <div *ngIf="isCreneaux" class="row mb-2" style="">
            <h4 class="textInfoIntervention">{{interventionSelected.label}} ({{interventionSelected.duration}} min)</h4>
            <div class="col-6" style="display: flex; justify-content: flex-start;">
                <button *ngIf="isBack" class="btn btn-secondary btn-sm btnPlanning col-lg-3 col-md-4 col-sm-6 col-8" (click)="back()">
                    <i aria-hidden="true" class="fal fa-arrow-alt-left"></i>
                    <span>&nbsp;</span>
                    <span class="ml-2" [translate]="'scaleform.precedent'"></span>
                </button>
            </div>
            <div class="col-6" style="display: flex; justify-content: flex-end;">
                <button *ngIf="isNext" class="btn btn-secondary btn-sm btnPlanning col-lg-3 col-md-4 col-sm-6 col-8" [translate]="'scaleform.suivant'" (click)="next()">
                    <span class="mr-2" [translate]="'scaleform.suivant'"></span>
                    <span>&nbsp;</span>
                    <i aria-hidden="true" class="fal fa-arrow-alt-right"></i>
                </button>
            </div>
        </div>
        <div *ngIf="isCreneaux" class="warning">
            <span [translate]="'planning.warning'"></span>
        </div>
        <div *ngIf="isCreneaux" class="planningContent">
            <table class="tableplanning">
                <caption></caption>
                <thead>
                    <tr>
                        <th scope="col" *ngFor="let day of listDaysWeek; index as dI" class="col-2 titleDay">
                            <span class="longDay">{{ day }}</span>
                            <span class="shortDay">{{ listDaysWeekShort[dI] }}</span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="listCreneaux">
                        <!--Lundi-->
                        <td>
                            <div>
                                <div *ngFor="let creneau of listMonday" class="row justify-content-center">
                                    <div *ngIf="creneau.reserved == 1" class="creneauLibre col-10 col-sm-6 pointer" (click)="selectRDV(creneau)">{{creneau.date | date:'HH:mm'}}</div>
                                    <div *ngIf="creneau.reserved != 1" class="creneauIndispo col-10 col-sm-6">{{creneau.date | date:'HH:mm'}}</div>
                                </div>
                            </div>
                        </td>
                        <!--Mardi-->
                        <td>
                            <div *ngFor="let creneau of listTuesday" class="row justify-content-center">
                                <div *ngIf="creneau.reserved == 1" class="creneauLibre col-10 col-sm-6 pointer" (click)="selectRDV(creneau)">{{creneau.date | date:'HH:mm'}}</div>
                                <div *ngIf="creneau.reserved != 1" class="creneauIndispo col-10 col-sm-6">{{creneau.date | date:'HH:mm'}}</div>
                            </div>
                        </td>
                        <!--Mercredi-->
                        <td>
                            <div *ngFor="let creneau of listWednesday" class="row justify-content-center">
                                <div *ngIf="creneau.reserved == 1" class="creneauLibre col-10 col-sm-6 pointer" (click)="selectRDV(creneau)">{{creneau.date | date:'HH:mm'}}</div>
                                <div *ngIf="creneau.reserved != 1" class="creneauIndispo col-10 col-sm-6">{{creneau.date | date:'HH:mm'}}</div>
                            </div>
                        </td>
                        <!--Jeudi-->
                        <td>
                            <div *ngFor="let creneau of listThursday" class="row justify-content-center">
                                <div *ngIf="creneau.reserved == 1" class="creneauLibre col-10 col-sm-6 pointer" (click)="selectRDV(creneau)">{{creneau.date | date:'HH:mm'}}</div>
                                <div *ngIf="creneau.reserved != 1" class="creneauIndispo col-10 col-sm-6">{{creneau.date | date:'HH:mm'}}</div>
                            </div>
                        </td>
                        <!--Vendredi-->
                        <td>
                            <div *ngFor="let creneau of listFriday" class="row justify-content-center">
                                <div *ngIf="creneau.reserved == 1" class="creneauLibre col-10 col-sm-6 pointer" (click)="selectRDV(creneau)">{{creneau.date | date:'HH:mm'}}</div>
                                <div *ngIf="creneau.reserved != 1" class="creneauIndispo col-10 col-sm-6">{{creneau.date | date:'HH:mm'}}</div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<!--3. Modale Informations Client-->
<div id="infosClientModal" class="modal">
    <div class="modal-content" id="modalClientContent">
        <div class="col-12 text-center">
            <span class="text-right pointer close" (click)="closeModal('infosClientModal')">
                <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
            </span>
            <h1 class="modal-title" [translate]="'planning.clientInfos'"></h1>
            <hr />
        </div>

        <div class="col-12 mt-3 mb-3 text-center row align-form">
            <h5>{{'planning.validRDV'|translate}} :</h5>
            <span>&nbsp;</span>
            <h4>{{RdvSelected.dateString}} {{heureDebutToDisplay | date:'HH:mm'}} - {{heureFinToDisplay | date:'HH:mm'}}</h4>
        </div>

        <div class="row mt-3 ml-1">
            <form [formGroup]="ctcPhoneForm" class="col-12 row align-form">
                <mat-form-field class="col-8 col-lg-4 col-md-6 col-sm-6">
                    <mat-label>{{'planning.ctcPhone'|translate}}</mat-label>
                    <input matInput formControlName="ctcPhone" required (blur)="savePhone()">
                </mat-form-field>
                <span *ngIf="isPhoneError" [translate]="'planning.errorPhone'" class="invalid-form"></span>
                <span *ngIf="isPhoneRegistered" class="primaryGreen"> <i aria-hidden="true" class="fal fa-check"></i></span>
            </form>
        </div>

        <fieldset class="noMargin row fieldset">
            <legend class="legend">{{ 'planning.searchClient' | translate }} </legend>
            <div class="filter">
                <form [formGroup]="searchClientForm" class="align-form">
                    <span class="mr-1 ">{{'scaleform.codepostal'|translate}}</span>
                    <mat-form-field class="col-4 mr-1">
                        <input matInput formControlName="postalCode" required autocomplete="off" (keyup)="resetClients($event)">
                    </mat-form-field>
                    <button id="btnSearch" class="btn btn-success col-lg-1 col-md-1 col-sm-2 col-2" (click)="searchClient()"><i aria-hidden="true" class="fal fa-search"></i></button>
                </form>
                <span *ngIf="noResults" class="text-center mt-2 font-italic" [translate]="'planning.noResult'"></span>
            </div>
        </fieldset>

        <div *ngIf="isClients" class="mt-4 row justify-content-center">
            <form [formGroup]="infosClientForm" class="row col-12">
                <mat-form-field class="col-12" id="selectClient">
                    <mat-label>{{'planning.customer'|translate}}</mat-label>
                    <mat-select formControlName="client" required>
                        <mat-option *ngFor="let client of clientsList"
                                    [value]="client"
                                    (click)="changeValueClient(client)"
                                    title="{{ client.socialReason | uppercase}} - {{client.name | uppercase}} {{client.firstname | titlecase}} ({{client.postalCode}} {{client.city}})">
                            {{ client.socialReason | uppercase}} - {{client.name | uppercase}} {{client.firstname | titlecase}} ({{client.postalCode}} {{client.city}})
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <h4 class="textInfoClient modal-text">{{ clientSelected.socialReason | uppercase}} - {{clientSelected.name | uppercase}} {{clientSelected.firstname | titlecase}} ({{clientSelected.postalCode}} {{clientSelected.city}})</h4>
                <div class="row justify-content-center col-12">
                    <button id="btnRegister" class="btn btn-success col-6 col-lg-3 col-md-4 col-sm-4" (click)="selectClient()" [translate]="'planning.register'"></button>
                </div>
            </form>
        </div>
    </div>
</div>

<!--4. Modale créneau indisponible-->
<div id="unavailableModal" class="modal">
    <div class="modal-content" id="unavailableContent">
        <span class="text-right mr-2 close pointer" (click)="closeModal('unavailableModal');">
            <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
        </span>
        <div class="container">
            <div class="upperText">
                <h2 class="text-center" [translate]="'planning.unavailableText1'"></h2>
                <div class="row">
                    <div class="text-center col-lg-8 col-md-10 col-sm-12 mx-auto modalFin p-4">
                        <p [translate]="'planning.unavailableText2'"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--5. Modale de confirmation du rendez-vous-->
<div id="confirmationModal" class="modal">
    <div class="modal-content" id="confirmationContent">
        <span class="text-right mr-2 close pointer" (click)="closeModal('confirmationModal');">
            <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
        </span>
        <div class="container">
            <i aria-hidden="true" class="fal fa-clipboard-check iconBackground"></i>
            <div class="upperText text-center">
                <h2 [translate]="'planning.confirmationRDVTitle'"></h2>
                <div class="row">
                    <div class="col-lg-8 col-md-10 col-sm-12 mx-auto modalFin p-4">
                        <p [translate]="'planning.confirmationRDVInfo'"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--6. Modale Loading-->
<div id="loadingModal" class="modal">
    <div class="modal-content" id="loadingContent">
        <div class="col-12 mt-5 mb-5 row justify-content-center loader-black">
            <mat-spinner diameter="70"> </mat-spinner>
        </div>
    </div>
</div>

<!--7. Modale Erreur-->
<div id="errorModal" class="modal">
    <div class="modal-content" id="errorContent">
        <h1 class="text-center mt-3" [translate]="'planning.errorTitle'"></h1>
        <span class="text-center mt-3" [translate]="'planning.errorMsg'"></span>
        <button class="btn btn-secondary col-lg-2 col-md-2 col-sm-3 col-4"
                style="align-self:center;"
                (click)="closeError()" [translate]="'planning.closeError'"></button>
    </div>
</div>
